const NavListData = [
    {
        id: 1,
        target: "home",
        name: `Home`,
        icon: "bi-house",
        active: true
    },

    {
        id: 2,
        target: "categories",
        name: `Categories`,
        icon: "bi-window-stack",
        active: false
    },

    {
        id: 3,
        target: "library",
        name: `My Library`,
        icon: "bi-heart",
        active: false
    },

    {
        id: 4,
        target: "bag",
        name: `My Bag`,
        icon: "bi-bag",
        active: false
    }
]

export default NavListData;